import { useAlertUiTranslation } from '../../../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { handleSelectedFilesValidation } from '@juvare/document-library/ui/features/file-selection';
import { humanReadableFileSize } from '@juvare/document-library/ui/utils';
import { Alert, List, ListItem, Typography } from '@mui/material';
import React from 'react';
export const ValidationErrorModalContent = ({ selectedFilesSize, selectedFilesCount, maxFilesSize, maxFilesCount, }) => {
    const { t } = useAlertUiTranslation();
    const { isMaxFilesCountExceeded, isMaxFilesSizeExceeded } = handleSelectedFilesValidation({
        selectedFilesCount,
        selectedFilesSize,
        maxFilesSize,
        maxFilesCount,
    });
    let errorText;
    if (isMaxFilesCountExceeded && isMaxFilesSizeExceeded) {
        errorText = t('pages.edit.richTextEditors.selectFilesWizard.validationErrorModal.mainContent.maxFilesCountAndSizeExceeded', {
            maxFilesCount,
            maxFilesSize: humanReadableFileSize(maxFilesSize),
        });
    }
    else if (isMaxFilesCountExceeded) {
        errorText = t('pages.edit.richTextEditors.selectFilesWizard.validationErrorModal.mainContent.maxFilesCountExceeded', {
            maxFilesCount,
        });
    }
    else if (isMaxFilesSizeExceeded) {
        errorText = t('pages.edit.richTextEditors.selectFilesWizard.validationErrorModal.mainContent.maxFilesSizeExceeded', {
            maxFilesCount,
            maxFilesSize: humanReadableFileSize(maxFilesSize),
        });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { color: themeColors.text.subtle }, errorText),
        React.createElement(Alert, { severity: 'warning', sx: { mt: 2 } },
            React.createElement(List, { sx: { m: 0, p: 0 } },
                isMaxFilesCountExceeded && (React.createElement(ListItem, { sx: { p: 0 } },
                    "\u2022",
                    ' ',
                    t('pages.edit.richTextEditors.selectFilesWizard.validationErrorModal.individualErrors.maxFilesCountExceeded', {
                        count: selectedFilesCount,
                        maxFilesCount,
                    }))),
                isMaxFilesSizeExceeded && (React.createElement(ListItem, { sx: { p: 0 } },
                    "\u2022",
                    ' ',
                    t('pages.edit.richTextEditors.selectFilesWizard.validationErrorModal.individualErrors.maxFilesSizeExceeded', {
                        size: humanReadableFileSize(selectedFilesSize),
                        maxFilesSize: humanReadableFileSize(maxFilesSize),
                    })))))));
};
